var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoutingBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66 3.45004C6.06 0.85504 2.1525 0.84754 1.5525 3.45004C1.2 4.97254 2.1675 6.26254 3.0075 7.06504C3.6225 7.64254 4.59 7.64254 5.205 7.06504C6.045 6.26254 7.005 4.97254 6.66 3.45004ZM4.1325 4.65004C3.72 4.65004 3.3825 4.31254 3.3825 3.90004C3.3825 3.48754 3.7125 3.15004 4.125 3.15004H4.1325C4.5525 3.15004 4.8825 3.48754 4.8825 3.90004C4.8825 4.31254 4.5525 4.65004 4.1325 4.65004Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4325 12.45C15.8325 9.85504 11.91 9.84754 11.3025 12.45C10.95 13.9725 11.9175 15.2625 12.765 16.065C13.38 16.6425 14.355 16.6425 14.97 16.065C15.8175 15.2625 16.785 13.9725 16.4325 12.45ZM13.8975 13.65C13.485 13.65 13.1475 13.3125 13.1475 12.9C13.1475 12.4875 13.4775 12.15 13.89 12.15H13.8975C14.31 12.15 14.6475 12.4875 14.6475 12.9C14.6475 13.3125 14.31 13.65 13.8975 13.65Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 14.8125H6.98996C6.11996 14.8125 5.36246 14.2875 5.06246 13.4775C4.75496 12.6675 4.97996 11.775 5.63246 11.1975L11.625 5.955C11.985 5.64 11.9925 5.2125 11.8875 4.92C11.775 4.6275 11.49 4.3125 11.01 4.3125H8.99996C8.69246 4.3125 8.43746 4.0575 8.43746 3.75C8.43746 3.4425 8.69246 3.1875 8.99996 3.1875H11.01C11.88 3.1875 12.6375 3.7125 12.9375 4.5225C13.245 5.3325 13.02 6.225 12.3675 6.8025L6.37496 12.045C6.01496 12.36 6.00746 12.7875 6.11246 13.08C6.22496 13.3725 6.50996 13.6875 6.98996 13.6875H8.99996C9.30746 13.6875 9.56246 13.9425 9.56246 14.25C9.56246 14.5575 9.30746 14.8125 8.99996 14.8125Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutingBlack);
export default __webpack_public_path__ + "static/media/routing_black.9df3bbe45d7c4f0f0cefe840f985b09b.svg";
export { ForwardRef as ReactComponent };